<template>
  <div class="container">
    <van-nav-bar :title="title" left-text="返回" left-arrow @click-left="onClickLeft" class="navbar" />
    <!-- body -->
    <cube-scroll ref="scroll" class="scroll-wrap">
        <div class="menu">
            <van-cell title="退出登录" @click="onLogout" is-link  />
        </div>
    </cube-scroll>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "设置"
    };
  },
  methods: {
    onClickLeft() {
      this.$redirect("/home/index");
    },
    onLogout() {
        this.$delCache('id')
        this.$delCache('username')
        this.$delCache('user_token')
        this.$delCache('role')
        this.$redirect('/home/login')
    }
  },
  activated() {}
};
</script>

<style lang="stylus" scoped>
.container {
  background: #f2f3f5;
}
.scroll-wrap {
  height: calc(100% - 0.92rem);
  position: fixed;
  top: 0.92rem;
  width: 100%;
}
.menu{
    padding: .3rem 0;
}
.navbar {
  color: #fff;
  background: #2196f3;
  position: fixed;
  top: 0;
  width: 100%;
}

>>>.van-nav-bar__title, .van-nav-bar .van-icon, .van-nav-bar__text {
  color: #fff;
}
</style>